// extracted by mini-css-extract-plugin
module.exports = {"header":"YqA7J6","usingNewGalleryStyles":"imWKB0","title":"ptBG4I","cancel":"uIETfi"};